import { BrowserRouter, Route, Routes } from "react-router-dom";
import * as Page from './app/pages/page'
import { urlsPages } from "./app/common/urls/urls-pages";
import { ProtectedPages } from "./app/common/auth-guard";
import { MonitorUi } from "./app/pages/page";

const App =()=> {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<Page.ErrorPage />} />
        <Route path={urlsPages.home} element={<Page.LandPage />} />
        <Route path={urlsPages.signin} element={<Page.Signin />} />
        <Route path={urlsPages.signup} element={<Page.Signup />} />
        <Route path={urlsPages.verifyEmail} element={<Page.VerifyEmail />} />
        <Route path={urlsPages.validateEmail} element={<Page.ValidateEmail />} />
        <Route path={urlsPages.monitor} element={<MonitorUi />} />
        <Route path={urlsPages.monitorConnection} element={<Page.MonitorConnectionUi />} />  
        <Route path={urlsPages.drills} element={ProtectedPages.Drills} />
        <Route path={urlsPages.sessionsList} element={ProtectedPages.ListSessions} />
        <Route path={urlsPages.workouts} element={ProtectedPages.Workouts} />
        <Route path={urlsPages.actions} element={ProtectedPages.Actions} />
        <Route path={urlsPages.connection} element={ProtectedPages.Connection} />              
        <Route path={urlsPages.sessionExecution} element={ProtectedPages.SessionsExecution} />
      </Routes>      
    </BrowserRouter>
  )
}
export {App}